import type { User } from '../types';

/** Accept only the canonical application roles. */
export function normalizeUserRole(value: unknown): User['role'] {
  const role = typeof value === 'string' ? value : '';
  return role === 'admin' || role === 'club-manager' ? role : 'user';
}
